var popUpCsfFunc = (function () {
  return {
    init: init
  };

  var csrfToken, captchaWidgetId, setModalVer, userLoggedIn, sourcePropVal, refPropVal, CalendlyIdleStart, userLoggedInCookie;

  function init() {
    var openCsfForm = document.querySelectorAll('.open-csf-form'),
      openCsfFormV2 = document.querySelectorAll('a.open-csf-form-v2, button.open-csf-form-v2'),
      formParentObj = document.querySelector('.popup-contact-form'),
      heroEventSource = document.querySelector('[name="event_source_hero"]') ? document.querySelector('[name="event_source_hero"]').value : null,
      footerEventSource = document.querySelector('[name="event_source_footer"]') ? document.querySelector('[name="event_source_footer"]').value : null,
      popupCsfExitModal = document.getElementById('popup_csf_exit_intent');
    
    //Open CSF Form
    for (var i = 0; i < openCsfForm.length; i++) {
      openCsfForm[i].addEventListener(
        'click',
        function (evt) {
          evt.preventDefault();

          var sourceValue = "";
          
          setModalVer = "v1";
          captchaWidgetId = undefined;
          userLoggedIn = false;
          userLoggedInCookie = Cookie.read(stage_env_cookie_prefix + 'bs_logging_id');

          loadZoomInfoScriptForForm(); // load zoominfo js

          loadRecaptchaForDemoModal(); // load recaptcha for demo form

          // Conditon for hero banner form
          if (this.classList.contains('hero-custom-utm-params')) {

            // Load Hero Event Source
            if (formParentObj.querySelector('[data-heroEvent]')) {
              var heroEventSourceInd = Object.assign({}, formParentObj.querySelector('[data-heroEvent]').dataset);
              heroEventSource = heroEventSourceInd.heroevent;
              footerEventSource = '';
              formParentObj.querySelector('[data-heroEvent]').value = heroEventSource;
            }
            if (formParentObj.querySelector('[data-footerEvent]')) {
              formParentObj.querySelector('[data-footerEvent]').value = '';
            }

            sourceValue = heroEventSource;

            // Add Hero UTM Source Value
            document.querySelector('[name="utm_source"]').value = heroEventSource;

          } else if (this.classList.contains('footer-custom-utm-params')) {
            // Conditon for Footer CTA form

            // Load Footer Event Source
            if (formParentObj.querySelector('[data-footerEvent]')) {
              var footerEventSourceInd = Object.assign({}, formParentObj.querySelector('[data-footerEvent]').dataset);
              footerEventSource = footerEventSourceInd.footerevent;
              heroEventSource = '';
              formParentObj.querySelector('[data-footerEvent]').value = footerEventSource;
            }
            if (formParentObj.querySelector('[data-heroEvent]')) {
              formParentObj.querySelector('[data-heroEvent]').value = '';
            }

            sourceValue = footerEventSource;

            // Add Footer UTM Source Value
            document.querySelector('[name="utm_source"]').value = footerEventSource;

          } else {
            if (formParentObj.querySelector('[data-footerEvent]')) {
              footerEventSource = '';
              formParentObj.querySelector('[data-footerEvent]').value = '';
            }
            if (formParentObj.querySelector('[data-heroEvent]')) {
              heroEventSource = '';
              formParentObj.querySelector('[data-heroEvent]').value = '';
            }
            document.querySelector('[name="utm_source"]').value = bsLib.getParameterByName('utm_source');
          }

          var modalContainer = document.querySelector('.pop-up-csf');
          if (modalContainer) {
            if (sourceValue) {
              sourcePropVal = sourceValue;
            } else {
              sourcePropVal = ((popUpCSFOptions.vwoShow) ? popUpCSFOptions.source : undefined);
            }

            //View Event
            WebEventTracker.logEvent(EDS.webEvents, 'LoadContactForm', bsLib.extend({
                action: 'view'
              },
              ((sourcePropVal) ? {source: sourcePropVal} : {})
            ));

            csfModal = new tingle.modal({
              arialabelledby: "popUpCsfModalTitle",
              ariadescribedby: "popUpCsfModalDesc",
              closeIconLight: true,
              focusAfterClosed: this,
              cssClass: ['pop-up-csf-form', 'pop-up-csf__container-form--ver1'],
              onClose: function () {
                //Close Event
                WebEventTracker.logEvent(EDS.webEvents, 'CsfInteractedWithCloseButton', bsLib.extend({
                  action: 'close'
                },
                ((sourcePropVal) ? {source: sourcePropVal} : {})
                ));

                CalendlyIdleStart = undefined;

                csfModal.destroy();
              },
            });
            csfModal.setContent(modalContainer.innerHTML);
            
            //form init
            CSFFormInit();
            csfModal.open();
            loadPopUpForms();

            // For varations 2
            if (!document.querySelector('[name="company"]')) {
              var element = document.getElementById("tingle-modal__close");
              element.classList.add("tingle-modal__close-inverse");
            }
          }
        },
        false
      );
    }

    //Open CSF Form V2
    for (var i = 0; i < openCsfFormV2.length; i++) {
      openCsfFormV2[i].addEventListener(
        'click',
        function (evt) {
          evt.preventDefault();

          setModalVer = "v2";
          captchaWidgetId = undefined;
          sourcePropVal = (typeof this.dataset.sourceval !== 'undefined' ? this.dataset.sourceval : 
          undefined);
          refPropVal = (typeof this.dataset.refval !== 'undefined' ? this.dataset.refval : 
          undefined)
          userLoggedIn = false;
          userLoggedInCookie = Cookie.read(stage_env_cookie_prefix + 'bs_logging_id');

          loadZoomInfoScriptForForm(); // load zoominfo js

          loadRecaptchaForDemoModal(); // load recaptcha for demo form

          document.querySelector('[name="utm_source"]').value = bsLib.getParameterByName('utm_source');

          var modalContainer = document.querySelector('.pop-up-csf');
          if (modalContainer) {

            //View Event
            WebEventTracker.logEvent(EDS.webEvents, 'LoadContactForm', bsLib.extend({
                action: 'view'
              },
              ((sourcePropVal) ? {source: sourcePropVal} : {})
            ));

            csfModal = new tingle.modal({
              arialabelledby: "popUpCsfModalTitle2",
              ariadescribedby: "popUpCsfModalDesc2",
              closeIconLight: true,
              focusAfterClosed: this,
              cssClass: ['pop-up-csf-form', 'pop-up-csf__container-form--ver2'],
              onClose: function () {
                //Close Event
                WebEventTracker.logEvent(EDS.webEvents, 'CsfInteractedWithCloseButton', bsLib.extend({
                  action: 'close'
                },
                ((sourcePropVal) ? {source: sourcePropVal} : {})
                ));

                csfModal.destroy();
              },
            });
            csfModal.setContent(modalContainer.innerHTML);
            
            //form init
            CSFFormInit();
            csfModal.open();
            loadPopUpForms();

            // For varations 2
            if (!document.querySelector('[name="company"]')) {
              var element = document.getElementById("tingle-modal__close");
              element.classList.add("tingle-modal__close-inverse");
            }
          }
        },
        false
      );
    }

    // Pop up CSF Exit Intent Modal functionality
    if (popupCsfExitModal) {
      // if cursor leaves the current window
      document.addEventListener("mouseout", function (e) {
        if (e.clientY < 1) {
          openPopUpCSFModal();
        }
      });

      function openPopUpCSFModal() {
        if (
          (!Cookie.read("closeExitModal")) &&
          !document.body.classList.contains("tingle-enabled")
        ) {
          
          setModalVer = "v1";
          captchaWidgetId = undefined;
          userLoggedIn = false;
          userLoggedInCookie = Cookie.read(stage_env_cookie_prefix + 'bs_logging_id');

          loadZoomInfoScriptForForm(); // load zoominfo js

          loadRecaptchaForDemoModal(); // load recaptcha for demo form

          //Add cookie to count load window expiry 30 days
          var countExitModal = Cookie.read("countExitModal");

          //check if cookie exists
          if (countExitModal == null) {
            Cookie.create("countExitModal", "1", 30);
          } else if (countExitModal == 1) {
            //check cookie count
            Cookie.create("closeExitModal", "1", 30);

            //delete count cookie
            Cookie.erase("countExitModal");
          }

          if (popUpCSFOptions.vwoShow) {
            sourcePropVal = popUpCSFOptions.source;
          }

          //Load amplitude event
          WebEventTracker.logEvent(EDS.webEvents, 'InteractedwithExitModal', bsLib.extend({
            action: 'load',
            showModal: true
          },
          ((sourcePropVal) ? {source: sourcePropVal} : {})
          ));

          var modalContainer = document.querySelector('.pop-up-csf');
          if (modalContainer) {

            //View Event
            WebEventTracker.logEvent(EDS.webEvents, 'LoadContactForm', bsLib.extend({
                action: 'view'
              },
              ((sourcePropVal) ? {source: sourcePropVal} : {})
            ));

            csfModal = new tingle.modal({
              arialabelledby: "popUpCsfModalTitle",
              ariadescribedby: "popUpCsfModalDesc",
              closeIconLight: true,
              cssClass: ['pop-up-csf-form', 'pop-up-csf__container-form--ver1'],
              onClose: function () {

                //add cookie with 30 day expiry
                Cookie.create("closeExitModal", "1", 30);

                //delete count cookie
                Cookie.erase("countExitModal");

                // Close amplitude event for Exit modal
                WebEventTracker.logEvent(EDS.webEvents, 'InteractedwithExitModal', bsLib.extend({
                  action: 'close'
                },
                ((sourcePropVal) ? {source: sourcePropVal} : {})
                ));

                //Close Event for CSF form
                WebEventTracker.logEvent(EDS.webEvents, 'CsfInteractedWithCloseButton', bsLib.extend({
                  action: 'close'
                },
                ((sourcePropVal) ? {source: sourcePropVal} : {})
                ));

                csfModal.destroy();
              },
            });
            csfModal.setContent(modalContainer.innerHTML);

            //form initialise
            CSFFormInit();
            csfModal.open();
            loadPopUpForms();

          }
        }
      }
    }

    /**
     * Calendly Events Check
     */
    function isCalendlyEvent(e) {
      return popUpCSFOptions.vwoShowCalendly && e.origin === "https://calendly.com" && e.data.event && e.data.event.indexOf("calendly.") === 0;
    }
     
    window.addEventListener("message", function(e) {
      if (isCalendlyEvent(e)) {
        if (e.data.event === "calendly.event_type_viewed") {
          var calendlyLoaderContent = document.querySelector('.tingle-modal .pop-up-csf__calendly-loading-container');

          if (calendlyLoaderContent) {
            calendlyLoaderContent.classList.add("hide");
          }

          WebEventTracker.logEvent(EDS.webEvents, 'CsfInteractedWithCalendly', 
            bsLib.extend({
              action: 'event_type_viewed'
            },
            ((sourcePropVal) ? {source: sourcePropVal} : {})
          ));

          CalendlyIdleStart = true;
          
          //60 second idle time start
          setTimeout(function() {
            if (CalendlyIdleStart !== undefined)  {
              WebEventTracker.logEvent(EDS.webEvents, 'CsfInteractedWithCalendly', 
                bsLib.extend({
                  action: 'idle_time'
                },
                ((sourcePropVal) ? {source: sourcePropVal} : {})
              ));
            }
          }, 1000*60);
        } else if (e.data.event === "calendly.date_and_time_selected") {
          WebEventTracker.logEvent(EDS.webEvents, 'CsfInteractedWithCalendly', 
            bsLib.extend({
              action: 'date_and_time_selected'
            },
            ((sourcePropVal) ? {source: sourcePropVal} : {})
          ));

          CalendlyIdleStart = undefined;
        } else if (e.data.event === "calendly.event_scheduled") {
          WebEventTracker.logEvent(EDS.webEvents, 'CsfInteractedWithCalendly', 
            bsLib.extend({
              action: 'event_scheduled'
            },
            ((sourcePropVal) ? {source: sourcePropVal} : {})
          ));

          CalendlyIdleStart = undefined;
        }
      }
    });
  }

  function loadPopUpForms() {
    var allPopUPforms = document.querySelectorAll('.popup-contact-form'),
    allPopUPContent = document.querySelectorAll('.popup-contact-form-content--v1, .popup-contact-form-content--v2');
    
    //Disable all forms
    if (allPopUPforms.length > 0) {
      for (var k = 0; k < allPopUPforms.length; k++) {
        allPopUPforms[k].classList.add("hide");
      }
    }
    if (allPopUPContent.length > 0) {
      for (var k = 0; k < allPopUPContent.length; k++) {
        allPopUPContent[k].classList.add("hide");
      }
    }

    //remove hide from current
    var curPopUp = document.querySelector('.tingle-modal .popup-contact-form--'+ setModalVer),
    curPopUpContent = document.querySelectorAll('.tingle-modal .popup-contact-form-content--'+ setModalVer);
    if (curPopUp) {
      curPopUp.classList.remove("hide");
      curPopUp.querySelector("input").focus();
    }

    //remove current content version
    if (curPopUpContent.length > 0) {
      for (var k = 0; k < curPopUpContent.length; k++) {
        curPopUpContent[k].classList.remove("hide");
      }
    }

    //show images after load
    lazyLoading.show();
  }

  function loadRecaptchaForDemoModal() {
    var captchaFieldJS = document.getElementById('recaptcha-js');
    if (!captchaFieldJS && typeof grecaptcha === 'undefined') {
      var scriptElm = document.createElement('script');
      scriptElm.setAttribute('id', 'recaptcha-js');
      scriptElm.setAttribute('type', 'text/javascript');
      scriptElm.setAttribute('src', 'https://www.google.com/recaptcha/api.js?ver=1.0');
      scriptElm.setAttribute('defer', 'defer');
      document.body.appendChild(scriptElm);
    }

    //csrfToken
    if (typeof csrf_token !== 'undefined') {
      csrfToken = csrf_token;
    } else if (!csrfToken) {
      setCSRFToken();
    }
  }

  function loadZoomInfoScriptForForm() {
    var zoomInfoJS = document.getElementById('zoominfo-script');

    if (!zoomInfoJS && enableZoomInfoJs) {
      window[(function(_XuP,_zF){var _iL="";for(var _o0=0;_o0<_XuP.length;_o0++){_45!=_o0;_zF>8;var _45=_XuP[_o0].charCodeAt();_45-=_zF;_45+=61;_45%=94;_45+=33;_iL==_iL;_iL+=String.fromCharCode(_45)}return _iL})(atob('e2pxNTItKCY3bCg8'), 33)] = '5d4c63d7351669843156';
      var zi = document.createElement('script');
      (zi.type = 'text/javascript'),
      (zi.async = true),
      (zi.id = 'zoominfo-script'),
      (zi.src = (function(_Mvc,_UU){var _3s="";for(var _ED=0;_ED<_Mvc.length;_ED++){var _TW=_Mvc[_ED].charCodeAt();_TW-=_UU;_UU>3;_3s==_3s;_TW+=61;_TW!=_ED;_TW%=94;_TW+=33;_3s+=String.fromCharCode(_TW)}return _3s})(atob('cn5+en1EOTl0fTgmczd9bXxzen59OG15dzkmczd+a3E4dH0='), 10)),
      document.readyState === 'complete' ? document.body.appendChild(zi) :
      window.addEventListener('load', function(){
        document.body.appendChild(zi)
      });
    }
  }

  function setCSRFToken() {
    bsLib.ajax(
      'GET',
      bsLib.railsHost() + '/user/token.json',
      {},
      true,
      {},
      // Success message for user token.
      function (data) {
        if (data.readyState === 4) {
          var dataRequest = bsLib.JSONParse(data.response),
            authenticityToken = document.querySelectorAll('input[name="authenticity_token"]');

          for (var i = 0; i < authenticityToken.length; i++) {
            authenticityToken[i].value = dataRequest.csrf_token;
          }
          csrfToken = dataRequest.csrf_token;
          csrf_token = csrfToken;
        }
      },
      // Custom Error message for user token.
      function () {
        return Messages.salesAndSupportPage.invalidUserToken;
      }
    );
  }

  function renderCaptchaField(guideCsfForm) {
    //check recaptcha valid 
    if (!guideCsfForm.showCaptchaValid()) {
      return false;
    }

    //remove captcha
    var captchaWidget, modalTingle = document.getElementById("tingle-modal-box"), captchaFieldShow = document.querySelector('.g-recaptcha.show'), captchaField = document.getElementById('contactformcaptchaPopUPCSFInvisibleV1');

    //set for invisible captcha
    if (setModalVer == "v2") {
      captchaField = document.getElementById('contactformcaptchaPopUPCSFInvisible');
    }
    //remove all grecaptcha from dom
    if (captchaFieldShow && typeof grecaptcha !== "undefined") {
      if (captchaFieldShow.innerHTML !== "") {
        captchaFieldShow.innerHTML = "";
      }
    }

    //recaptcha render from JS
    if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.ready !== 'undefined' && captchaField.childNodes.length === 0) {
      grecaptcha.ready(function() {
        if (!modalTingle.hasAttribute('data-g-widget-id')) {
          captchaWidget = grecaptcha.render(captchaField, {
            'sitekey' : captchaField.dataset.sitekey,
            'theme' : 'light',
            'badge': 'bottomright',
            'size': 'invisible',
            'callback' : function () {
              //recaptcha callback 
              return guideCsfForm.init(true);
            }
          });
  
          modalTingle.dataset.gWidgetId = captchaWidget;
        }
      });
    } else if (typeof grecaptcha !== "undefined" && captchaField.childNodes.length >= 0) {
      captchaWidget = modalTingle.dataset.gWidgetId;
    }
    return captchaWidget;
  }
  function CSFFormInit() {
    var contactFormChecker = [],
      formCheckerObj = {},
      mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
      intS = 0;

    //Close Pop Up CSF
    var popupContactClose = document.querySelectorAll('.popup-contact-form--close');
    for (var i = 0; i < popupContactClose.length; i++) {
      popupContactClose[i].addEventListener(
        'click',
        function (evt) {
          evt.preventDefault();
          //close modal
          csfModal.close();
        },
        false
      );
    }

    var tyLinks = document.querySelectorAll('.tingle-modal .pop-up-csf__in_ty-resource a');
    //TY modal click
    for (var i = 0; i < tyLinks.length; i++) {
      tyLinks[i].addEventListener(
        'click', function() {
          var that = this,
          sourcePropValTy;

          if (sourcePropVal) {
            sourcePropValTy = sourcePropVal;
          } else if (popUpCSFOptions.vwoShow) {
            sourcePropValTy = popUpCSFOptions.source;
          }

          WebEventTracker.logEvent(EDS.webEvents, 'CSFModalLinkClick', bsLib.extend({
            action: 'click',
            LinkTo: that.href
          },
          ((sourcePropValTy) ? {source: sourcePropValTy} : {})
          ));
      }, false);
    }

    //Contact Form
    var contentContactForm = document.querySelectorAll('.tingle-modal .popup-contact-form');
    for (var i = 0; i < contentContactForm.length; i++) {
      formCheckerObj = {};
      formCheckerObj.formObj = contentContactForm[i];
      formCheckerObj.index = i;
      formCheckerObj.uniqueID = bsLib.uniqueID();

      var companyText = '';
      if (document.querySelector('[name="email"]').value != '') {
        var emailExtension = document.querySelector('[name="email"]').value,
          emailStr = emailExtension.split("@"),
          finalDomain = emailStr[emailStr.length - 1].split('.');
        companyText = finalDomain[0];
      }

      formCheckerObj.nameField = formCheckerObj.formObj.querySelector('[name="name"]');
      formCheckerObj.emailField = formCheckerObj.formObj.querySelector('[name="email"]');
      formCheckerObj.companyField = (formCheckerObj.formObj.querySelector('[name="company"]')) ? formCheckerObj.formObj.querySelector('[name="company"]') : companyText;

      if (!userLoggedIn) {
        var showCaptchaMsg = document.querySelector(".tingle-modal .popup-contact-form--"+ setModalVer +" .btn-contact-bottom-wrapper-text");
        if (showCaptchaMsg) {
          showCaptchaMsg.classList.remove("hide");
        }
      }

      if (userLoggedInCookie) {
        var urlLinkEnv = "https://automate.browserstack.com";

        if (window.location.hostname !== "www.browserstack.com") {
          urlLinkEnv = "https://automate-k8s-devos.bsstag.com";
        }

        bsLib.ajax(
          'GET',
          urlLinkEnv + '/api/v1/user?product=wp',
          {},
          true,
          {},
          // Success
          function (data) {
            if (data.readyState === 4) {
              var dataRequest = bsLib.JSONParse(data.response);
              if (typeof dataRequest.success !== 'undefined' && dataRequest.success) {
                var formCheckerCSF = document.querySelector('.tingle-modal .popup-contact-form--' + setModalVer);

                if (formCheckerCSF) {
                  var nameField = formCheckerCSF.querySelector('[name="name"]'),
                  emailField = formCheckerCSF.querySelector('[name="email"]'),
                  companyField = formCheckerCSF.querySelector('[name="company"]');
                  
                  if (nameField) {
                    nameField.value = dataRequest.data.name;
                  }

                  if (emailField) {
                    emailField.value = dataRequest.data.email;
                  }

                  if (companyField) {
                    companyField.value = dataRequest.data.company;
                  }
                }
              }
            }
          },
          function () {},
          false,
          true //withCredentials
        );
      }

      formCheckerObj.queryType = formCheckerObj.formObj.querySelector('[name="query_type"]');
      formCheckerObj.messageField = formCheckerObj.formObj.querySelector('[name="message"]');
      formCheckerObj.formCSFCheckbox = formCheckerObj.formObj.querySelector('.form-csf-checkbox');
      formCheckerObj.requestType = formCheckerObj.formObj.querySelector('[name="request_type"]');
      formCheckerObj.utf8 = formCheckerObj.formObj.querySelector('[name="utf8"]');
      formCheckerObj.formsubmit = formCheckerObj.formObj.querySelector('[name="commit"]');
      formCheckerObj.authenticityToken = formCheckerObj.formObj.querySelector('[name="authenticity_token"]');
      formCheckerObj.sendEmail = formCheckerObj.formObj.querySelector('[name="send_email"]');
      formCheckerObj.utmCampaign = formCheckerObj.formObj.querySelector('[name="utm_campaign"]');
      formCheckerObj.utmAdgroup = formCheckerObj.formObj.querySelector('[name="utm_adgroup"]');
      formCheckerObj.gclid = formCheckerObj.formObj.querySelector('[name="gclid"]');
      formCheckerObj.utmSource = formCheckerObj.formObj.querySelector('[name="utm_source"]');
      formCheckerObj.ctaRef = formCheckerObj.formObj.querySelector('[name="cta_ref"]');
      formCheckerObj.capterraPixel = formCheckerObj.formObj.querySelector('[name="csf_capterra_pixel"]');
      formCheckerObj.recotapPixel = formCheckerObj.formObj.querySelector('[name="popup_csf_recotap_pixel"]');

      formCheckerObj.eventSourceHero = formCheckerObj.formObj.querySelector('[data-heroEvent]');

      formCheckerObj.eventSourceFooter = formCheckerObj.formObj.querySelector('[data-footerEvent]');

      formCheckerObj.InteractedwithCSFBool = true;

      //Zoominfo hidden fields value
      formCheckerObj.title = formCheckerObj.formObj.querySelector('[name="title"]');
      formCheckerObj.phoneNumber = formCheckerObj.formObj.querySelector('[name="phone_number"]');
      formCheckerObj.mobileNumber = formCheckerObj.formObj.querySelector('[name="mobile_number"]');
      formCheckerObj.companyCountry = formCheckerObj.formObj.querySelector('[name="company_country"]');
      formCheckerObj.companyWebsite = formCheckerObj.formObj.querySelector('[name="company_website"]');
      formCheckerObj.managementLevel = formCheckerObj.formObj.querySelector('[name="management_level"]');
      formCheckerObj.companySize = formCheckerObj.formObj.querySelector('[name="company_size"]');
      formCheckerObj.jobFunction = formCheckerObj.formObj.querySelector('[name="job_function"]');
      formCheckerObj.jobDepartment = formCheckerObj.formObj.querySelector('[name="job_department"]');
      formCheckerObj.companyIndustry = formCheckerObj.formObj.querySelector('[name="company_industry"]');
      formCheckerObj.secondaryEmailAddress = formCheckerObj.formObj.querySelector('[name="secondary_email_address"]');
      formCheckerObj.emailAddress = formCheckerObj.formObj.querySelector('[name="email_address"]');
      formCheckerObj.formLinkedInLead = formCheckerObj.formObj.querySelector('[name="person_linkedin_url"]');
      formCheckerObj.formEmailValidityCheck = formCheckerObj.formObj.querySelector('[name="neverbounce_email_status"]');
      formCheckerObj.formEstimatedRevenue = formCheckerObj.formObj.querySelector('[name="company_revenue"]');
      formCheckerObj.formFreeEmail = formCheckerObj.formObj.querySelector('[name="free_email"]');
      formCheckerObj.formGenericEmail = formCheckerObj.formObj.querySelector('[name="generic_email"]');
      formCheckerObj.formMalformedEmail = formCheckerObj.formObj.querySelector('[name="malformed_email"]');

      //Set Query Params value
      formCheckerObj.utmCampaign.value = bsLib.getParameterByName('utm_campaign');
      formCheckerObj.utmAdgroup.value = bsLib.getParameterByName('utm_adgroup');
      formCheckerObj.gclid.value = bsLib.getParameterByName('gclid');

      contactFormChecker[i] = formCheckerObj;
    }

    var guideCsfForm = (function (csrfToken, contactFormChecker, sourcePropValLocal, refPropValLocal) {
      return {
        init: init,
        setScope: setScope,
        resetForm: resetForm,
        validateFields: _validateFields,
        showCaptchaValid: showCaptchaValid
      };

      var formCheckerObj = {}, csfCheckboxValues = [], uniqueID, index;

      function setScope(scope) {
        formCheckerObj = {};
        index = getFormIndex(scope);
        formCheckerObj = contactFormChecker[index];
        uniqueID = formCheckerObj.uniqueID;
      }

      function init(checkPromise) {
        if (checkPromise) {
          return new Promise(function (resolve, reject) {
            formCheckerObj.formsubmit.setAttribute('disabled', 'disabled');
            formCheckerObj.formsubmit.value = formCheckerObj.formsubmit.dataset.btndisabled;

            var emailExtension = document.querySelector('[name="email"]').value,
              emailStr = emailExtension.split('@'),
              finalDomain = emailStr[emailStr.length - 1].split('.');

            csfCheckboxValues = [];
            //With the call() method, you can write a method that can be used on different objects.
            Array.prototype.forEach.call(document.querySelectorAll('input[name="csf_testing"]:checked'), function (el) {
              csfCheckboxValues.push(el.value);
            });

            var messageElse = 'I want a demo for... user skipped option';
            if (csfCheckboxValues.length > 0) {
              messageElse = "'I want a demo for...' " + csfCheckboxValues.join(' & ');
            }

            var dataPayload = {
              name: formCheckerObj.nameField.value,
              email: formCheckerObj.emailField.value,
              query_type: formCheckerObj.queryType.value,
              message: formCheckerObj.messageField ? formCheckerObj.messageField.value : messageElse,
              company: formCheckerObj.companyField ? formCheckerObj.companyField.value : finalDomain[0],
              send_email: formCheckerObj.sendEmail.value,
              authenticity_token: formCheckerObj.authenticityToken.value,
              utf8: formCheckerObj.utf8.value,
              request_type: formCheckerObj.requestType.value,
              utm_campaign: formCheckerObj.utmCampaign.value,
              utm_adgroup: formCheckerObj.utmAdgroup.value,
              gclid: formCheckerObj.gclid.value,
              utm_source: formCheckerObj.utmSource.value,
              ref: ((popUpCSFOptions.vwoShow) ? popUpCSFOptions.ref : ""),
              enterprise_pricing_ref: 'true',
              page: window.location.href,
              cta_ref: refPropValLocal ? refPropValLocal : formCheckerObj.ctaRef.value,
              source: 'wp_form',
              title: formCheckerObj.title ? formCheckerObj.title.value : '',
              phone_number: formCheckerObj.phoneNumber ? formCheckerObj.phoneNumber.value : '',
              mobile_number: formCheckerObj.mobileNumber ? formCheckerObj.mobileNumber.value : '',
              company_country: formCheckerObj.companyCountry ? formCheckerObj.companyCountry.value : '',
              company_website: formCheckerObj.companyWebsite ? formCheckerObj.companyWebsite.value : '',
              management_level: formCheckerObj.managementLevel ? formCheckerObj.managementLevel.value : '',
              company_size: formCheckerObj.companySize ? formCheckerObj.companySize.value : '',
              job_function: formCheckerObj.jobFunction ? formCheckerObj.jobFunction.value : '',
              job_department: formCheckerObj.jobDepartment ? formCheckerObj.jobDepartment.value : '',
              company_industry: formCheckerObj.companyIndustry ? formCheckerObj.companyIndustry.value : '',
              secondary_email_address: formCheckerObj.secondaryEmailAddress ? formCheckerObj.secondaryEmailAddress.value : '',
              email_address: formCheckerObj.emailAddress ? formCheckerObj.emailAddress.value : '',
              person_linkedin_url: formCheckerObj.formLinkedInLead ? formCheckerObj.formLinkedInLead.value : '',
              neverbounce_email_status: formCheckerObj.formEmailValidityCheck ? formCheckerObj.formEmailValidityCheck.value : '',
              company_revenue: formCheckerObj.formEstimatedRevenue ? formCheckerObj.formEstimatedRevenue.value : '',
              free_email: formCheckerObj.formFreeEmail ? formCheckerObj.formFreeEmail.value : '',
              generic_email: formCheckerObj.formGenericEmail ? formCheckerObj.formGenericEmail.value : '',
              malformed_email: formCheckerObj.formMalformedEmail ? formCheckerObj.formMalformedEmail.value : '',
            };

            if (setModalVer == "v2") {
              dataPayload["ref"] = refPropValLocal ? refPropValLocal : formCheckerObj.ctaRef.value;
            }

            if (typeof grecaptcha === undefined) {
              reject();
            }

            var grecaptchaResponse = grecaptcha.getResponse(captchaWidgetId);
            if (!grecaptchaResponse) {
              new bsAlert({
                alertType: 'error',
                timeout: 5000,
                text: Messages.salesAndSupportPage.noRecaptcha,
              });

              reject();
            }

            //store form info for freshchat user creation demo chat logged out exp
            var demoChatInfo = {
              name: formCheckerObj.nameField ? formCheckerObj.nameField.value.trim() : '',
              emailId: formCheckerObj.emailField ? formCheckerObj.emailField.value.trim() : '',
              company: formCheckerObj.companyField ? formCheckerObj.companyField.value.trim() : '',
              demoMsg: messageElse,
            };

            dataPayload['g-recaptcha-response'] = grecaptchaResponse;

            // xhr request for sending form data
            bsLib.ajax(
              'POST',
              bsLib.railsHost() + '/contact',
              //Form Data
              dataPayload,
              true,
              //Form Header
              {
                'X-CSRF-Token': csrfToken,
                'content-type': 'application/x-www-form-urlencoded; charset=UTF-8', // Setting content type.
              },
              //Form Success
              function (data) {
                if (data.readyState === 4) {
                  var dataRequest = bsLib.JSONParse(data.response);
                  if (dataRequest.success === true) {

                    //All after success logic
                    contactFormSuccess(dataRequest, demoChatInfo);
                    
                    resolve();
                  } else {
                    if (typeof dataRequest.message !== 'undefined') {
                      new bsAlert({
                        alertType: 'error',
                        timeout: 5000,
                        text: dataRequest.message,
                      });
                    }
                    _logFormSubmit('FormSubmitError');

                    reject();
                  }
                }
              },
              //Form Error
              function () {
                _logFormSubmit('FormSubmitError');
                reject();
              }
            );
          });
        } else {
          formCheckerObj.formsubmit.setAttribute('disabled', 'disabled');
          formCheckerObj.formsubmit.value = formCheckerObj.formsubmit.dataset.btndisabled;

          var emailExtension = document.querySelector('[name="email"]').value,
            emailStr = emailExtension.split('@'),
            finalDomain = emailStr[emailStr.length - 1].split('.');

          csfCheckboxValues = [];
          //With the call() method, you can write a method that can be used on different objects.
          Array.prototype.forEach.call(document.querySelectorAll('input[name="csf_testing"]:checked'), function (el) {
            csfCheckboxValues.push(el.value);
          });

          var messageElse = 'I want a demo for... user skipped option';
          if (csfCheckboxValues.length > 0) {
            messageElse = "'I want a demo for...' " + csfCheckboxValues.join(' & ');
          }
        
          var dataPayload = {
            name: formCheckerObj.nameField.value,
            email: formCheckerObj.emailField.value,
            query_type: formCheckerObj.queryType.value,
            message: formCheckerObj.messageField ? formCheckerObj.messageField.value : messageElse,
            company: formCheckerObj.companyField ? formCheckerObj.companyField.value : finalDomain[0],
            send_email: formCheckerObj.sendEmail.value,
            authenticity_token: formCheckerObj.authenticityToken.value,
            utf8: formCheckerObj.utf8.value,
            request_type: formCheckerObj.requestType.value,
            utm_campaign: formCheckerObj.utmCampaign.value,
            utm_adgroup: formCheckerObj.utmAdgroup.value,
            gclid: formCheckerObj.gclid.value,
            utm_source: formCheckerObj.utmSource.value,
            ref: ((popUpCSFOptions.vwoShow) ? popUpCSFOptions.ref : ""),
            enterprise_pricing_ref: 'true',
            page: window.location.href,
            cta_ref: ((popUpCSFOptions.vwoShow) ? popUpCSFOptions.cta_ref : formCheckerObj.ctaRef.value),
            source: 'wp_form',
            title: formCheckerObj.title ? formCheckerObj.title.value : '',
            phone_number: formCheckerObj.phoneNumber ? formCheckerObj.phoneNumber.value : '',
            mobile_number: formCheckerObj.mobileNumber ? formCheckerObj.mobileNumber.value : '',
            company_country: formCheckerObj.companyCountry ? formCheckerObj.companyCountry.value : '',
            company_website: formCheckerObj.companyWebsite ? formCheckerObj.companyWebsite.value : '',
            management_level: formCheckerObj.managementLevel ? formCheckerObj.managementLevel.value : '',
            company_size: formCheckerObj.companySize ? formCheckerObj.companySize.value : '',
            job_function: formCheckerObj.jobFunction ? formCheckerObj.jobFunction.value : '',
            job_department: formCheckerObj.jobDepartment ? formCheckerObj.jobDepartment.value : '',
            company_industry: formCheckerObj.companyIndustry ? formCheckerObj.companyIndustry.value : '',
            secondary_email_address: formCheckerObj.secondaryEmailAddress ? formCheckerObj.secondaryEmailAddress.value : '',
            email_address: formCheckerObj.emailAddress ? formCheckerObj.emailAddress.value : '',
            person_linkedin_url: formCheckerObj.formLinkedInLead ? formCheckerObj.formLinkedInLead.value : '',
            neverbounce_email_status: formCheckerObj.formEmailValidityCheck ? formCheckerObj.formEmailValidityCheck.value : '',
            company_revenue: formCheckerObj.formEstimatedRevenue ? formCheckerObj.formEstimatedRevenue.value : '',
            free_email: formCheckerObj.formFreeEmail ? formCheckerObj.formFreeEmail.value : '',
            generic_email: formCheckerObj.formGenericEmail ? formCheckerObj.formGenericEmail.value : '',
            malformed_email: formCheckerObj.formMalformedEmail ? formCheckerObj.formMalformedEmail.value : '',
          };

          //for cta_ref
          if (setModalVer == "v2") {
            dataPayload["cta_ref"] = refPropValLocal ? refPropValLocal : formCheckerObj.ctaRef.value;
            dataPayload["ref"] = refPropValLocal ? refPropValLocal : formCheckerObj.ctaRef.value;
            dataPayload["utm_source"] = formCheckerObj.utmSource.value;
          }
        
          if (showCaptchaValid()) {
            var grecaptchaResponse = grecaptcha.getResponse(captchaWidgetId);

            if (grecaptchaResponse.length === 0) {
              new bsAlert({
                alertType: 'error',
                timeout: 5000,
                text: Messages.salesAndSupportPage.noRecaptcha,
              });

              return false;
            }

            dataPayload['g-recaptcha-response'] = grecaptchaResponse;
          }

          //store form info for freshchat user creation demo chat logged out exp
          var demoChatInfo = {
            name: formCheckerObj.nameField ? formCheckerObj.nameField.value.trim() : '',
            emailId: formCheckerObj.emailField ? formCheckerObj.emailField.value.trim() : '',
            company: formCheckerObj.companyField ? formCheckerObj.companyField.value.trim() : '',
            demoMsg: messageElse,
          };

          // xhr request for sending form data
          bsLib.ajax(
            'POST',
            bsLib.railsHost() + '/contact',
            //Form Data
            dataPayload,
            true,
            //Form Header
            {
              'X-CSRF-Token': csrfToken,
              'content-type': 'application/x-www-form-urlencoded; charset=UTF-8', // Setting content type.
            },
            //Form Success
            function (data) {
              if (data.readyState === 4) {
                var dataRequest = bsLib.JSONParse(data.response);
                if (dataRequest.success === true) {
                  
                  //All after success logic
                  contactFormSuccess(dataRequest, demoChatInfo);

                } else {
                  if (typeof dataRequest.message !== 'undefined') {
                    new bsAlert({
                      alertType: 'error',
                      timeout: 5000,
                      text: dataRequest.message,
                    });
                  }
                  _logFormSubmit('FormSubmitError');
                }
              }
            },
            //Form Error
            function () {
              _logFormSubmit('FormSubmitError');
            }
          );
        }
      }

      function showCaptchaValid() {
        return (setModalVer == "v1" || setModalVer == "v2") && !userLoggedIn;
      }

      function contactFormSuccess(dataRequest, demoChatInfo) {
        //Capterra Conversion tracking pixel
        if (formCheckerObj.capterraPixel.value === '1') {
          trackCapterraConversions();
        }

        //linkedIn Pixel
        if (window.lintrk !== undefined) {
          window.lintrk('track', { conversion_id: 9342713 });
        }

        _logFormSubmit('FormSubmitSuccess');
        _afterSubmitSuccess();

        var modalContainer = document.querySelector('.pop-up-csf__success'),
          tyContent = document.querySelector('.tingle-modal .pop-up-csf__in_ty'),
          calendlyContent = document.querySelector('.tingle-modal .pop-up-csf__calendly'),
          calendlyLoaderContent = document.querySelector('.tingle-modal .pop-up-csf__calendly-loading-container');

        //check if calendly condition added
        if (setModalVer == "v1" && popUpCSFOptions.vwoShowCalendly) {
          contatcformContent = document.querySelector('.tingle-modal .pop-up-csf__container-form-content');

          if (contatcformContent) {
            contatcformContent.classList.add("hide");
          }

          if (calendlyContent) {
            calendlyContent.classList.remove("hide");
          }

          if (calendlyLoaderContent) {
            calendlyLoaderContent.classList.remove("hide");
          }

          //calendly func
          var calendlyField = document.getElementById('CalendlyScriptWidget');

          if (!calendlyField) {
            var script = document.createElement('script');
            script.src = 'https://assets.calendly.com/assets/external/widget.js';
            script.async = 'async';
            script.id = "CalendlyScriptWidget";
            script.type = 'text/javascript';
            document.getElementsByTagName('body')[0].appendChild(script);
          }
          
          //render from JS
          var intS2 = 0, eTime2 = setInterval(function () {
            if (typeof Calendly !== 'undefined') {
              Calendly.initInlineWidget({
                url: popUpCSFOptions.calendly,
                parentElement: document.getElementById('calendlyBstackModalForm'),
                prefill: {
                  name: demoChatInfo.name ? demoChatInfo.name : '',
                  email: demoChatInfo.emailId ? demoChatInfo.emailId : ''
                }
              });
            }

            if (++intS2 >= 30 || typeof Calendly !== 'undefined') { clearInterval(eTime2); }
          }, 100);
        } else if ((setModalVer == "v1" || setModalVer == "v2") && tyContent) {
          contatcformContent = document.querySelector('.tingle-modal .pop-up-csf__container-form-content');

          if (contatcformContent) {
            contatcformContent.classList.add("hide");
          }

          tyContent.classList.remove("hide");
          var setEmailId = tyContent.querySelector('.pop-up-csf__in_ty-main-desc-email');
          if (setEmailId) {
            setEmailId.innerHTML = demoChatInfo.emailId ? demoChatInfo.emailId : ' your email.';
          }
        } else {
          var modal = new tingle.modal({
            arialabelledby: 'tyModalTitle',
            ariadescribedby: 'tyModalDesc',
            closeIconLight: true,
            cssClass: ['small-modal'],
            onOpen: function () {
              csfModal.destroy();
            },
            onClose: function () {
              modal.destroy();
            },
          });
          modal.setContent(modalContainer.innerHTML);
          modal.open();
        }

        setTimeout(function () {
          lazyLoading.show();
        });

        //reset captcha
        if (showCaptchaValid()) {
          grecaptcha.reset(captchaWidgetId);
        }
      }

      function _validateFields() {
        var formValid = true,
          namerError = document.getElementById('name-error' + uniqueID),
          emailError = document.getElementById('email-error' + uniqueID),
          messageError = document.getElementById('message-error' + uniqueID),
          companyError = document.getElementById('company-error' + uniqueID),
          needDemoError = document.getElementById('need-demo-error' + uniqueID),
          recaptchaError = document.getElementById("recaptcha-error" + uniqueID),
          emailNotifyMsg = formCheckerObj.emailField.parentElement.querySelector(".email-notify-msg");
        //Remove all errors
        removeAllError();
        
        if (window.innerWidth > 979 && formCheckerObj.formsubmit && !formCheckerObj.formsubmit.style.minWidth && formCheckerObj.formsubmit.offsetWidth > 120) {
          formCheckerObj.formsubmit.style.minWidth = formCheckerObj.formsubmit.offsetWidth + "px";
        }

        if (formCheckerObj.nameField.value.length === 0) {
          formValid = _showError(
            formCheckerObj.nameField,
            namerError,
            'name-error' + uniqueID,
            Messages.salesAndSupportPage.invalidName
          );
        }

        if (formCheckerObj.emailField.value == '') {
          emailNotifyMsg.classList.add('hide');
          formValid = _showError(
            formCheckerObj.emailField,
            emailError,
            'email-error' + uniqueID,
            Messages.salesAndSupportPage.noemail
          );
        } else if (!formCheckerObj.emailField.value.match(mailformat)) {
          emailNotifyMsg.classList.add('hide');
          formValid = _showError(
            formCheckerObj.emailField,
            emailError,
            'email-error' + uniqueID,
            Messages.salesAndSupportPage.invalidEmail
          );
        } else if (formCheckerObj.emailField.dataset.notvalid === "1") {
          emailNotifyMsg.classList.add('hide');
          formValid = _showError(
            formCheckerObj.emailField,
            emailError,
            "email-error" + uniqueID,
            (formCheckerObj.emailField.dataset.corporateCheck === '1') ? Messages.salesAndSupportPage.invalidWorkEmail : Messages.salesAndSupportPage.invalidEmail
          );
        } else {
          emailNotifyMsg.classList.remove('hide');
        }

        if (formCheckerObj.formObj.querySelector('[name="message"]')) {
          if (formCheckerObj.messageField.value.length === 0) {
            formValid = _showError(
              formCheckerObj.messageField,
              messageError,
              'message-error' + uniqueID,
              Messages.salesAndSupportPage.invalidMessage
            );
          }
        }

        if (formCheckerObj.companyField) {
          if (formCheckerObj.companyField.value.length === 0) {
            formValid = _showError(
              formCheckerObj.companyField,
              companyError,
              'company-error' + uniqueID,
              Messages.salesAndSupportPage.noCompanyName
            );
          }
        }

        //Checkbox Need demo required validation
        if (formCheckerObj.formCSFCheckbox) {
          var csfDemoValues = [];

          Array.prototype.forEach.call(document.querySelectorAll('input[name="csf_testing"]:checked'), function (el) {
            csfDemoValues.push(el.value);
          });

          if (csfDemoValues.length == 0) {
            formValid = _showError(
              formCheckerObj.formCSFCheckbox,
              needDemoError,
              'need-demo-error' + uniqueID,
              Messages.salesAndSupportPage.invalidNeedHelp
            );
          }
        }

        if (showCaptchaValid()) {
          var grecaptchaResponse = typeof grecaptcha !== 'undefined' && grecaptcha.hasOwnProperty("getResponse") ? grecaptcha.getResponse(captchaWidgetId) : '';
          if (grecaptchaResponse.length === 0 && setModalVer != "v2" && setModalVer != "v1") {
            formValid = _showError(
              document.getElementById('contactformcaptchaPopUPCSF'),
              recaptchaError,
              "recaptcha-error" + uniqueID,
              Messages.salesAndSupportPage.noRecaptcha
            );
          }
        }

        return formValid;
      }

      function removeAllError() {
        //Remove all error element
        var errorMsg = formCheckerObj.formObj.querySelectorAll('.error-message');
        for (var i = 0; i < errorMsg.length; i++) {
          errorMsg[i].remove();
        }
        //remove error border class
        var errorMsg = formCheckerObj.formObj.parentElement.querySelectorAll('.error-border');
        for (var i = 0; i < errorMsg.length; i++) {
          errorMsg[i].classList.remove('error-border');
        }
      }

      //Get form index
      function getFormIndex(formObj) {
        var index;
        for (var i = 0; i < contactFormChecker.length; i++) {
          if (contactFormChecker[i].formObj == formObj) {
            index = contactFormChecker[i].index;
          }
        }

        return index;
      }

      function _showError(fieldName, fieldError, errorName, errorMessage) {
        inlineError.showError(fieldName, fieldError, errorName, errorMessage);

        csfCheckboxValues = [];
        //With the call() method, you can write a method that can be used on different objects.
        Array.prototype.forEach.call(
          document.querySelectorAll('input[name="csf_testing"]:checked'),
          function(el) {
            csfCheckboxValues.push(el.value);
          }
        );
        
        
        WebEventTracker.logEvent(EDS.webEvents, 'SubmitContactForm', bsLib.extend({
          field: fieldName.getAttribute('name'),
          InvalidInput: true,
          message: errorMessage,
          QueryTypeSubmitted: 'Sales',
          ProductTypeSubmitted: (csfCheckboxValues.length > 0) ? csfCheckboxValues.join(' & ') : ""
        },
        ((sourcePropValLocal) ? {source: sourcePropValLocal} : {})
        ));
        
        return false;
      }

      function _afterSubmitSuccess() {
        resetForm();
      }

      function resetForm() {
        formCheckerObj.formObj.reset(); //Reset form
      }

      function _logFormSubmit(status) {
        var data = {},
          queryType = formCheckerObj.queryType.getAttribute('data-query-text'),
          queryVal = formCheckerObj.queryType.getAttribute('value'),
          rectotapPixel = formCheckerObj.recotapPixel;

        data.experiment = 'false';
        data[status] = true;
        data.QueryTypeSubmitted = queryType ? queryType : 'No query type';

        if (heroEventSource) {
          data.source = heroEventSource;
        } else if (footerEventSource) {
          data.source = footerEventSource;
        } else if (sourcePropValLocal) {
          data.source = sourcePropValLocal;
        } else if (popUpCSFOptions.vwoShow) {
          data.source = popUpCSFOptions.source;

          //VWO goal for CSF conversion success
          if (status === "FormSubmitSuccess") {
            window._vis_opt_queue = window._vis_opt_queue || [];
            window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(206);});
          }
        }

        data.ProductTypeSubmitted = (csfCheckboxValues.length > 0) ? csfCheckboxValues.join(' & ') : "";
        
        WebEventTracker.logEvent(EDS.webEvents, 'SubmitContactForm', data);
        
        if (typeof ga !== "undefined") {
          ga('browserstack.send', 'event', {
            eventCategory: 'Contact',
            eventAction: 'CtaClick',
            eventLabel: 'Submit',
            eventValue: queryVal,
          });
        }

        //rectotapPixel
        if (status === "FormSubmitSuccess" && rectotapPixel) {
          var gaGoalValue = (rectotapPixel.value.trim() === 'rtm_custom_free_demo') ? 'demo_signup' : 'contact_sales';
          if (typeof ga !== "undefined") {
            ga('browserstack.send', 'event', 'recotap_event', 'conversion', gaGoalValue);
          }
        }
      }

      // Capterra Tracking conversion function
      function trackCapterraConversions() {
        var capterra_vkey = '0876d89c2b6371e45d7ccf97748244ae',
        capterra_vid = '2113793',
        ct = document.createElement('img');
        ct.src = 'https://ct.capterra.com/capterra_tracker.gif?vid='
          + capterra_vid + '&vkey=' + capterra_vkey;
        ct.classList.add("hide");
        document.body.appendChild(ct);
      }
    })(csrfToken, contactFormChecker, sourcePropVal, refPropVal);

    function intereactedWithFormField(formCheckerElm, data) {
      var index;
      for (var k = 0; k < contactFormChecker.length; k++) {
        if (contactFormChecker[k].formObj == formCheckerElm.formObj) {
          index = contactFormChecker[k].index;
        }
      }

      //add source params for home page csf
      if (sourcePropVal) {
        data.source = sourcePropVal;
      } else if (popUpCSFOptions.vwoShow) {
        data.source = popUpCSFOptions.source;
      }

      //add interaction for form first interaction
      if (contactFormChecker[index].InteractedwithCSFBool) {
        contactFormChecker[index].InteractedwithCSFBool = false;

        WebEventTracker.logEvent(EDS.webEvents, "InteractedWithSalesForm", data);
      }

      var dataEvnName = "InteractedWithSalesForm";
      switch (data.field) {
        case 'name':
          dataEvnName = "CsfInteractedWithNameField";
          break;
        case 'email':
          dataEvnName = "CsfInteractedWithEmailField";
          break;
        case 'company':
          dataEvnName = "CsfInteractedWithCompanyField";
          break;
        case 'message':
          dataEvnName = "CsfInteractedWithMessageField";
          break;
        case 'i need a demo for':
          dataEvnName = "CsfInteractedWithCheckbox";
          break;
        case 'submit':
          dataEvnName = "SubmitContactForm";
          break;
        default:
      }

      WebEventTracker.logEvent(EDS.webEvents, dataEvnName, data);
    }

    //recaptcha render from JS
    var eTime = setInterval(function () {
      if (captchaWidgetId == undefined) {
        captchaWidgetId = renderCaptchaField(guideCsfForm);
      }

      if (++intS >= 30 || captchaWidgetId) { clearInterval(eTime); }
    }, 100);

    //Contact Form
    for (var j = 0; j < contactFormChecker.length; j++) {
      contactFormEle = contactFormChecker[j];

      var heroEventSource = contactFormEle.eventSourceHero ? contactFormEle.eventSourceHero.value : null, footerEventSource = contactFormEle.eventSourceFooter ? contactFormEle.eventSourceFooter.value : null;

      //Interacted with fields
      contactFormEle.nameField.addEventListener('blur', function (event) {
        intereactedWithFormField(contactFormEle, {
          field: 'name',
          action: 'click'
        });
      });

      contactFormEle.emailField.addEventListener('blur', function (event) {
        // get unique id for email error
        for (var i = 0; i < contactFormChecker.length; i++) {
          if (contactFormChecker[i].formObj == this.closest('form.popup-contact-form')) {
            contactFormElemt = contactFormChecker[i];
            var emailUniqueID = contactFormChecker[i].uniqueID;
          }
        }
        // Amplitude event
        intereactedWithFormField(contactFormElemt, {
          field: 'email',
          action: 'click'
        });

        // email blur validation
        if (contactFormElemt.emailField) {
          var validEmail = true,
            that = this,
            submitBtn = that.closest('form.popup-contact-form').querySelector('.demo-csf-submit-btn'),
            emailError = document.getElementById("email-error" + emailUniqueID),
            emailNotifyMsg = contactFormElemt.emailField.parentElement.querySelector(".email-notify-msg");

          //false valid dataset
          that.dataset.notvalid = "0";

          //remove existing error
          if (emailError) {
            emailError.remove();
          }

          if (that.value.length == 0 || !bsLib.validEmail(that.value)) {
            validEmail = false;
            
            that.classList.add("error-border");
            emailNotifyMsg.classList.add('hide');
            that.insertAdjacentHTML('afterend', '<span class="error-message" id= "email-error' + emailUniqueID + '">' + (that.value.length == 0 ? Messages.salesAndSupportPage.noemail : Messages.salesAndSupportPage.invalidEmail) + '</span>');
          } else {
            that.classList.remove("error-border");
            emailNotifyMsg.classList.remove('hide');
          }

          if (validEmail) {
            //Disable submit button
            if (submitBtn) {
              submitBtn.setAttribute("disabled", "disabled");
              submitBtn.value = Messages.salesAndSupportPage.validateText;
            }

            // corporate email validation check
            var bstackAPI,
              emailErrorMsg;

            if (contactFormElemt.emailField.dataset.corporateCheck === '1') {
              bstackAPI = bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value) + "&source=paid_ads";
              emailErrorMsg = Messages.salesAndSupportPage.invalidWorkEmail;
            } else {
              bstackAPI = bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value);
              emailErrorMsg = Messages.salesAndSupportPage.invalidEmail;
            }
            
            bsLib.ajax(
              "GET",
              bstackAPI,
              {},
              true,
              {
                "X-CSRF-Token": csrfToken,
                "content-type": "application/x-www-form-urlencoded; charset=utf-8" // Setting content type.
              },
              function(data) {
                var dataRequest = bsLib.JSONParse(data.response);

                //remove disable
                if (submitBtn) {
                  submitBtn.removeAttribute("disabled");
                  submitBtn.value = submitBtn.dataset.valueText;
                }

                if (dataRequest.valid === false) {
                  that.dataset.notvalid = "1";

                  that.classList.add("error-border");
                  if (that.parentNode.getElementsByClassName("error-message").length === 0) {
                    emailNotifyMsg.classList.add('hide');
                    that.insertAdjacentHTML('afterend', '<span class="error-message" id= "email-error' + emailUniqueID + '">' + emailErrorMsg + '</span>');
                  }
                }
              },
              function() {}
            );
          }
        }
      });

      if (contactFormEle.formObj.querySelector('[name="message"]')) {
        contactFormEle.messageField.addEventListener('blur', function (event) {
          intereactedWithFormField(contactFormEle, {
            field: 'message',
            action: 'click'
          });
        });
      }

      if (contactFormEle.formObj.querySelector('[name="csf_testing"]')) {
        var csf_checkbox_field = contactFormEle.formObj.querySelectorAll('[name="csf_testing"]');

        for (var u = 0; u < csf_checkbox_field.length; u++) {
          csf_checkbox_field[u].addEventListener('change', function() {
            if (this.checked) {
              intereactedWithFormField(contactFormEle, {
                field: 'i need a demo for',
                action: 'click'
              });
            }
          });
        }
        
      }

      if (contactFormEle.companyField) {
        contactFormEle.companyField.addEventListener('blur', function (event) {
          intereactedWithFormField(contactFormEle, {
            field: 'company',
            action: 'click'
          });
        });
      }

      //Submit Contact Form
      contactFormEle.formObj.addEventListener('submit', function (e) {
        e.preventDefault();

        var heroEventSource = this.querySelector('[data-heroEvent]') ? this.querySelector('[data-heroEvent]').value : null,
          footerEventSource = this.querySelector('[data-footerEvent]') ? this.querySelector('[data-footerEvent]').value : null;

          //submit Interaction
          intereactedWithFormField(contactFormEle, {
            field: 'submit',
            action: 'click'
          });

        guideCsfForm.setScope(this);

        if (!guideCsfForm.validateFields()) {
          return false;
        }

        if (grecaptcha !== "undefined") {
          if (!userLoggedIn) {
            grecaptcha.execute(captchaWidgetId); 
          } else {
            guideCsfForm.init(false);
          }
        }
        return false;
      });
    }
  }
})();

popUpCsfFunc.init();
